import { CheckoutUrlBuilder } from './CheckoutUrlBuilder';

/**
 * The shared entry point for building a `/checkout` URL. Other modules (web
 * links, the CLI, bio buttons) call this and chain the fluent builders.
 *
 * @example
 * checkoutUrlBuilder()
 *   .product(p => p.urlCode('andy.us1').listing('listing_1').variant('v2').quantity(2))
 *   .theme('dark-contrast')
 *   .preferences(p => p.ccOnly().mobileCta('floating'))
 *   .onSuccess(s => s.redirectTo('https://shop.example/thanks'))
 *   .url(); // "/checkout?type=product&c=andy.us1&listing_id=listing_1&…"
 */
export function checkoutUrlBuilder(): CheckoutUrlBuilder {
  return new CheckoutUrlBuilder();
}
